import { render } from "./SiteTemplates.vue?vue&type=template&id=3c01b0f6&scoped=true"
import script from "./SiteTemplates.vue?vue&type=script&lang=js"
export * from "./SiteTemplates.vue?vue&type=script&lang=js"

import "./SiteTemplates.vue?vue&type=style&index=0&id=3c01b0f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c01b0f6"]])

export default __exports__